const USERNAME_KEY = 'Un';

export const setUserNameCookie = (username: string) => {
  // this enables working with this on local dev, since Chrome doesn't really work with
  // domain-scoped cookies on localhost
  const expirationDate = new Date();
  expirationDate.setFullYear(new Date().getFullYear() + 1);
  if (window.location.hostname === 'localhost') {
    document.cookie = `Un=${username};expires=${expirationDate.toUTCString()};samesite=None;secure;`;
  } else {
    document.cookie = `Un=${username};domain=bandwidth.com;expires=${expirationDate.toUTCString()};samesite=None;secure;`;
  }
};

export const clearUserNameCookie = (username: string) => {
  const expirationDate = new Date();
  expirationDate.setFullYear(new Date().getFullYear() + 1);
  if (window.location.hostname === 'localhost') {
    // this enables working with this local dev, since Chrome doesn't really work with
    // domain-scoped cookies on localhost
    document.cookie = `Un=${username};samesite=None;expires=${expirationDate.toUTCString()};secure;max-age=0`;
  } else {
    // expire the cookie immediately
    document.cookie = `Un=${username};domain=bandwidth.com;expires=${expirationDate.toUTCString()};samesite=None;secure;max-age=0`;
  }
};

export const getUserNameFromCookie = () => {
  const cookieValue = document.cookie
    .split(';')
    .find((item) => item.trim().startsWith(USERNAME_KEY));
  return cookieValue ? cookieValue.split('=')[1] : '';
};
